var React = require('react');

function BNBIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M7.92983 10.085L12.5906 5.42436L17.2538 10.0874L19.9658 7.37544L12.5906 0L5.21795 7.37304L7.92983 10.085ZM0.59082 11.9996L3.3029 9.28754L6.01481 11.9995L3.30275 14.7115L0.59082 11.9996ZM7.92983 13.915L12.5906 18.5756L17.2537 13.9127L19.9671 16.6232L19.9658 16.6247L12.5906 24L5.21771 16.6272L5.21387 16.6234L7.92983 13.915ZM19.1669 12.0011L21.879 9.28904L24.5909 12.0009L21.8788 14.713L19.1669 12.0011Z","fill":"#F3BA2F","key":0}),React.createElement("path",{"d":"M15.3414 11.9986H15.3426L12.5907 9.2466L10.5569 11.2804H10.5568L10.3232 11.5141L9.84124 11.9962L9.8374 11.9999L9.84124 12.0038L12.5907 14.7534L15.3426 12.0014L15.344 11.9999L15.3414 11.9986Z","fill":"#F3BA2F","key":1})]);
}

BNBIcon.defaultProps = {"width":"20","height":"20","viewBox":"0 0 25 24","fill":"none"};

module.exports = BNBIcon;

BNBIcon.default = BNBIcon;
